import { nameOfFactory } from "@libs/utils/name-of.utils.ts";

export interface UserCommunicationsFormValues {
  smsName?: string;
  workPhone?: string;
  email?: string;
  signatureFile?: string;
  signatureUrl?: string;
}

export const userCommunicationsFormNameOf =
  nameOfFactory<UserCommunicationsFormValues>();
